import React, { useContext } from 'react';
import styled from '@emotion/styled';
import WhiteZolaLogo from 'assets/images/logos/zola-logo-minimal-white.svg';
import BlackZolaLogo from 'assets/images/logos/zola-logo-minimal.svg';
import { ThemeContext } from '../../context';

const Footer = (): JSX.Element => {
  const { light_or_dark } = useContext(ThemeContext);

  const FooterLink = ({ children, ...rest }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
    return (
      <a target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  };

  const StyledFooterLink = styled(FooterLink)`
    color: inherit;

    &:hover {
      color: inherit;
    }
  `;
  const Container = styled.div`
    font-family: 'Proxima Nova';
    font-size: 12px;
    color: ${light_or_dark === 'light' ? 'black' : 'white'};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 80px;
    padding-bottom: 200px;
  `;

  const Row = styled.div`
    > *:not(:first-child) {
      margin-left: 20px;
    }
    margin-bottom: 8px;
  `;

  const ZolaSignature = styled.span`
    font-size: 14px;
    margin-top: 12px;
  `;

  const Logo = styled.img`
    width: 66px;
    margin-bottom: 20px;
  `;

  return (
    <Container>
      <Logo src={light_or_dark === 'light' ? BlackZolaLogo : WhiteZolaLogo} />
      <Row>
        <StyledFooterLink href="/about">About Zola</StyledFooterLink>
        <StyledFooterLink href="https://help.zola.com/hc/categories/115000284811-For-Wedding-Guests">
          Guest FAQs
        </StyledFooterLink>
        <StyledFooterLink>Order Status</StyledFooterLink>
        <StyledFooterLink>support@zola.com</StyledFooterLink>
        <span>1 (408) 657-ZOLA</span>
      </Row>
      <Row>
        <span>&copy; {new Date().getFullYear()} Zola, Inc. All rights reserved. </span>
        <span>
          <StyledFooterLink href="/webaccessibility">Web Accessibility</StyledFooterLink> /{' '}
          <StyledFooterLink href="/privacy#CA-privacy-rights">Privacy Rights</StyledFooterLink>
        </span>
      </Row>
      <ZolaSignature>Made with love by Zola.</ZolaSignature>
    </Container>
  );
};

export default Footer;
